// SAM-1309 (U21): a pass status is read as a state, not as the action that produced it. The database names the status
// «Cancel» (and once misspelled «Proccesing»); the screens say «Cancelled». Everything else is shown as the row names it.
const STATUS_WORDS: Record<string, string> = { cancel: 'Cancelled', cancelled: 'Cancelled', proccesing: 'Processing' };

export const passStatusLabel = (name: string | null | undefined): string => {
  const raw = (name ?? '').trim();
  return STATUS_WORDS[raw.toLowerCase()] ?? raw;
};
